<template>
    <p
        class="plans-feature"
        v-if="featuresText[value]"
        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
        :content="featuresText[value](features[value])"
    >
        <i class="fa fa-check" />
        <span>{{ featuresText[value](features[value]) }}</span>
    </p>
</template>
<script>
import { Features } from "./feature-items";

export default {
    name: "CardFeatureText",
    props: {
        value: {
            type: String,
            required: true,
        },
        features: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            featuresText: {
                [Features.AGENT.FREE_AGENT_COUNT]: (val) => `${val} ${this.$t("plans.freeAgent")}`,
                [Features.AGENT.AGENT_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("headBar.representative")}`,
                [Features.CHATBOT.MAX_SESSION_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("chatbotv2.chatbot")}`,
                [Features.CHATBOT.INTEGRATION_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("search.chatbotIntegration")}`,
                [Features.CHATBOT.STORY_COUNT_LIMIT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("plans.chatbotStory")}`,
                [Features.CHATBOT.VERSION_HISTORY_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("plans.chatbotVersionHistory")}`,
                [Features.CHAT.AUTO_TRANSLATION]: () => this.$t("plans.autoTranslate"),
                [Features.CHAT.VOICE_CALLING]: () => this.$t("billing.audioCallUnlimited"),
                [Features.CHAT.VIDEO_CALLING]: () => this.$t("billing.videoCallUnlimited"),
                [Features.SYSTEM.DATA_PROTECT]: () => this.$t("plans.dataSecurity"),
                [Features.SYSTEM.ACCESS_ALL_AGENT]: () => this.$t("plans.accessibleToAllAgents"),
                [Features.WHATSAPP.NOT_ADDITIONAL_PRICE]: () => this.$t("plans.noExtraCosts"),
                [Features.REPORT.REPORT]: (val) =>
                    val === "basic-report" ? this.$t("plans.normalreporting") : this.$t("plans.detailedReporting"),
                [Features.REPORT.VISITOR_TRACKING]: () => this.$t("plans.instantVisitor"),
                [Features.CHAT.FILE_AND_VOICE_MESSAGE]: () => this.$t("plans.fileAndVoiceShare"),
                [Features.SYSTEM.TEAM_CHAT_ENTEGRATION]: () => this.$t("plans.teamChatIntegration"),
                [Features.SUPPORT.SUPPORT]: (val) =>
                    val === "basic-support" ? this.$t("plans.standardSupport") : this.$t("plans.support"),
                [Features.SUPPORT.SOFTWARE_SUPPORT]: () => this.$t("plans.softwareSupport"),
                [Features.SUPPORT.DEDICATED_CUSTOMER_SUPPORT]: () => this.$t("plans.specialCustomerSupport"),
                [Features.SYSTEM.CHAT_AND_NOTIFICATION]: () => this.$t("plans.chatAndNotifications"),
                [Features.SYSTEM.CHAT_BALLOON_CUSTOMIZATION]: () => this.$t("plans.chatBaloonCustomization"),
                [Features.SYSTEM.REMOVE_SUPSIS_LOGO]: () => this.$t("plans.removeLogo"),
                [Features.SYSTEM.DATABASE_CONNECTION]: () => this.$t("plans.isolatedDatabaseConnection"),
                [Features.SYSTEM.SINGLE_PANEL_ACCESS]: () => this.$t("plans.onePanelManagement"),
                [Features.SYSTEM.MAX_DISK_SIZE]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val / 1024 / 1024 / 1024}GB`} ${this.$t(
                        "plans.storage"
                    )}`,
                [Features.SYSTEM.TICKET_SYSTEM]: () => this.$t("plans.ticketFeature"),
                [Features.SYSTEM.WHATSAPP_ENTEGRATION]: () => this.$t("whatsappChannel.whatsappIntegration"),
                [Features.SYSTEM.INSTAGRAM_ENTEGRATION]: () => this.$t("plans.instagramIntegration"),
                [Features.SYSTEM.MESSENGER_ENTEGRATION]: () => this.$t("messenger.integrationTitle"),
                [Features.SYSTEM.TELEGRAM_ENTEGRATION]: () => this.$t("plans.telegramIntegration"),
                [Features.TRIGGERS.MAX_TRIGGER_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val} ${this.$t("plans.smartTrigger")}`}`,
                [Features.WHATSAPP.BROADCAST_PER_MESSAGE]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val}₺ Toplu Mesaj Başına`}`,
                [Features.WHATSAPP.BULK_MESSAGE_SENDING]: () => this.$t("plans.broadcastMessaging"),
                [Features.WHATSAPP.MESSAGE_UNREGISTERED_NUMBERS]: () => this.$t("plans.chatWithNonContacts"),
                [Features.WHATSAPP.PERSONALIZED_BROADCAST_MESSAGE]: () => this.$t("plans.personalizedBroadcasts"),
                [Features.CHATBOT.CHATBOT_BUTTON_ACTIVITY]: () => this.$t("plans.automaticChatbotButton"),
                [Features.SYSTEM.CHATBOT_ENTEGRATION]: () => this.$t("wp.chatbotIntegration"),
                [Features.WHATSAPP.CONTROL_WHATSAPP]: () => this.$t("plans.whatsappManaging"),
                [Features.SYSTEM.VISITOR_START_CHAT]: () => this.$t("plans.startChatWithVisitor"),
                [Features.SYSTEM.MAIL_ENTEGRATION]: () => this.$t("plans.mailIntegration"),
                [Features.SYSTEM.SMS_ENTEGRATION]: () => this.$t("plans.smsIntegration"),
                [Features.ARCHIVE.CHAT_ARCHIVE_TIME]: (val) =>
                    `${
                        val < 0
                            ? this.$t("plans.unlimited")
                            : `${val / 7} ${this.$t("plans.week")} ${this.$t("chatbotv2.archive")}`
                    }`,
                [Features.CHATBOT.ACTIVE_CHATBOT_LIMIT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val} ${this.$t("plans.activeChatbot")}`}`,
                [Features.SYSTEM.READY_CONTENTS]: () => this.$t("plans.readyContents"),
                [Features.SYSTEM.ALL_ENTEGRATION]: () => this.$t("chatbotv2.allIntegrations"),
                [Features.SYSTEM.WEBHOOK_ENTEGRATION]: () => this.$t("plans.webhookIntegration"),
                [Features.SYSTEM.CALENDER_ENTEGRATION]: () => this.$t("plans.calendarIntegration"),
                [Features.SYSTEM.TASK_MANAGEMENT_ENTEGRATION]: () => this.$t("plans.taskManagement"),
                [Features.SYSTEM.AUTO_REZERVATION]: () => this.$t("plans.automaticReservation"),
                [Features.SYSTEM.FLEXIBLE_BILLING]: () => this.$t("plans.flexibleBilling"),
                [Features.CHAT.COPILOT]: () => this.$t("plans.aiAssistant"),
                [Features.REPORT.SPECIAL_REPORT]: () => this.$t("plans.specialReporting"),
                [Features.SYSTEM.PERMISSION_CONTROL]: () => this.$t("plans.confirmationFeature"),
                [Features.WHATSAPP.CHANNEL_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val} ${this.$t("whatsappChannel.whatsappChannel")}`}`,
                [Features.WHATSAPP.BUSINESS_CHANNEL_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val} ${this.$t("plans.businessChannel")}`}`,
                [Features.MESSENGER.CHANNEL_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val} Channel`}`,
                [Features.INSTAGRAM.CHANNEL_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val} Channel`}`,

                [Features.SERVICES.FLEXIBLE_PRICING]: () => this.$t("plans.flexiblePricing"),
                [Features.SERVICES.UNLIMITED_CB_SCENARIO]: () => this.$t("plans.unlimitedCBScenario"),
                [Features.SERVICES.FREE_FIRST_SCENARIO]: () => this.$t("plans.freeFirstScenario"),
                [Features.SERVICES.RIGHT_TO_CANCEL]: () => this.$t("plans.rightToCancel"),
                [Features.SERVICES.UNLIMITED_LEARN]: () => this.$t("plans.unlimitedLearn"),
                [Features.SERVICES.ALL_PLATFORM_INTEGRATION]: () => this.$t("plans.allPlatformIntegration"),
                [Features.SERVICES.AI_SUPPORT]: () => this.$t("plans.aiSupport"),
                [Features.SERVICES.CREATIVE_AI]: () => this.$t("plans.creativeAI"),
                [Features.SERVICES.UNLIMITED_SESSION]: () => this.$t("plans.unlimitedSession"),
                [Features.SERVICES.ASSISTANT_FROM_WEB]: () => this.$t("plans.assistantFromWebsite"),
                [Features.SERVICES.ASSISTANT_FROM_DOC]: () => this.$t("plans.assistantFromDoc"),
                [Features.SERVICES.MOBILE_APP]: () => this.$t("plans.mobileApp"),
                [Features.SERVICES.WHATSAPP]: () => "Whatsapp",
                [Features.SERVICES.EMAIL]: () => "Email",
                [Features.SERVICES.WEB]: () => "Web",
                [Features.SERVICES.INSTAGRAM]: () => "Instagram",
                [Features.SERVICES.MESSENGER]: () => "Messenger",
                [Features.SERVICES.MANAGE_INBOX]: () => this.$t("plans.manageInbox"),
                [Features.SERVICES.COMMENT_MANAGEMENT]: () => this.$t("plans.commentManagement"),
                [Features.SERVICES.PRIVATE_REPLY_MESSAGE]: () => this.$t("plans.privateReplyMessage"),
                [Features.SERVICES.MENTION_TICKET]: () => this.$t("plans.mentionTicket"),
                [Features.SERVICES.MANAGE_WITH_CHATBOT]: () => this.$t("plans.manageWithChatbot"),
            },
        };
    },
};
</script>
<style>
.plans-feature {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    i {
        color: #ec4b1d !important;
        padding-right: 5px;
    }

    p {
        font-size: 13px;
        margin-bottom: 1em;
        color: #171725 !important;

        &:first-child {
            margin-top: 1em;
        }
    }

    &::-webkit-scrollbar {
        display: none;
    }

    &::-webkit-scrollbar-thumb {
        background: $base-color;
    }
}
</style>
